import UseFetch from "../components/UseFetch";
import { decryptData, defaulUrl, fmt, Loading } from "../components/const";
import { useEffect, useRef, useState } from "react";
import FacturesByFournisseur from "./FacturesByFournisseurs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import $ from "jquery";

const Solde = () => {
    const { data: fournisseurs, isloading } = UseFetch('fournisseurs/solde');
    const [totalDette, setTotalDette] = useState(0);
    const [facturesByIdFourn, setFacturesByIdFourn] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);
    const printElement = useRef(null);

    const handleShowFactureByFourn = (e, id) => {
        setIsLoading(true)
        e.preventDefault()
        fetch(`${defaulUrl}fournisseurs/${id}/factures`, {
            method: "GET",
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            }
        }).then((response) => response.json())
            .then(data => {
                setIsLoading(false)
                setFacturesByIdFourn(data)
            })
    }

    useEffect(() => {
        setTotalDette(fournisseurs?.reduce((prev, curr) => prev + (+curr.reste), 0))
    }, [fournisseurs])

    $(tableRef.current).DataTable();

    // 🔹 Fonction PDF dynamique pour les fournisseurs
    const printFournisseurs = (title, tab = []) => {
        const user = decryptData("USER");

        if (!tab || tab.length === 0) {
            alert("Aucune donnée à imprimer !");
            return;
        }

        const doc = new jsPDF("landscape");

        // Entête PDF
        doc.setFontSize(18);
        doc.setTextColor(0, 123, 255);
        doc.text("FANSAN TEXTIL", 105, 20, { align: "center" });
        doc.setFontSize(14);
        doc.text(title?.toUpperCase() || "", 105, 30, { align: "center" });

        // Colonnes visibles dans le tableau HTML
        const headers = ["N°", "PRENOMS ET NOM", "TELEPHONE", "ADRESSE", "SOLDE"];
        const data = tab.map((fourn, index) => [
            index + 1,
            `${fourn.prenoms} ${fourn.nom}` || "",
            fourn.telephone || "",
            fourn.adresse || "",
            fmt(fourn.reste) + (fourn.devise || "")
        ]);

        autoTable(doc, {
            startY: 40,
            head: [headers],
            body: data,
            headStyles: { fillColor: [52, 58, 64], textColor: 255 },
            theme: "grid",
        });

        // Pied de page
        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(10);
        doc.text(new Date().toLocaleDateString(), 105, pageHeight - 20, { align: "center" });
        doc.text(user?.droit?.toUpperCase() || "", 105, pageHeight - 10, { align: "center" });

        doc.save(`${title || "fournisseurs"}.pdf`);
    };

    return (
        <div className="Solde">
            <div className="row my-2">
                <div className="col-lg-6 h2 text-primary">
                    SOLDE DES FOURNISSEURS
                </div>
            </div>
            {isloading ? <Loading /> : fournisseurs?.length ?
                <div className="row p-2">
                    <button className="btn btn-primary m-1 w-auto ms-auto" onClick={() => printFournisseurs("Situation solde fournisseurs", fournisseurs)}>
                        <i className="bx bx-printer"></i>
                    </button>
                    <div className="table-responsive p-2" ref={printElement}>
                        <table ref={tableRef} className="table table-hover table-striped table-bordered border-primary">
                            <thead className="table-primary border-primary">
                                <tr>
                                    <th>N°</th>
                                    <th>PRENOMS ET NOM</th>
                                    <th>TELEPHONE</th>
                                    <th>ADRESSE</th>
                                    <th>SOLDE</th>
                                    <th className="text-end">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody className="plage">
                                {fournisseurs.map((fourn, index) => (
                                    <tr key={index} className="tr">
                                        <td>{index + 1}</td>
                                        <td className="fourn">{`${fourn.prenoms} ${fourn.nom}`}</td>
                                        <td>{fourn.telephone}</td>
                                        <td>{fourn.adresse}</td>
                                        <td>{(+fourn.reste).toLocaleString()}{fourn.devise}</td>
                                        <td className="text-end">
                                            <button data-bs-toggle="modal" data-bs-target="#exampleModal" className="btn btn-success" onClick={(e) => handleShowFactureByFourn(e, fourn.id)}>FACTURE NON REMBOURSEES</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                :
                <div className="row justify-content-center p-2 bg-danger-subtle text-danger fs-3">Aucun fournisseur trouvé!</div>
            }

            <FacturesByFournisseur data={facturesByIdFourn} isloading={isLoading} />
        </div>
    );
}

export default Solde;
